// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__VhS1R","logo":"styles_logo__s3OD-"};